'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { Menu, X } from 'lucide-react'; 

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: "Inicio", href: "#hero" },
    { name: "Funcionalidades", href: "#funcionalidades" },
    { name: "Precios", href: "#precios" },
    { name: "Beneficios", href: "#beneficios" },
    { name: "Certificación", href: "#certificacion" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? "bg-white/90 backdrop-blur-md shadow-sm py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <Link href="/" className="flex items-center gap-2 group">
          <div className="flex flex-col">
            <span className="text-2xl font-black tracking-tighter text-[#1e2c6e] leading-none mb-0.5">
              <span className="flex items-center gap-1.5">
                <div className="flex flex-col gap-0.5">
                  <div className="w-5 h-1 bg-[#1e2c6e] rounded-full" />
                  <div className="w-5 h-1 bg-[#1e2c6e] rounded-full opacity-60 ml-1" />
                  <div className="w-5 h-1 bg-[#1e2c6e] rounded-full opacity-30 ml-2" />
                </div>
                KERN
              </span>
            </span>
          </div>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.name}
              href={link.href}
              className="text-slate-600 font-bold text-sm hover:text-[#1e2c6e] transition-colors"
            >
              {link.name}
            </Link>
          ))}
        </nav>

        {/* Action Button */}
        <div className="hidden md:block">
          <Link href="/login">
            <Button className="bg-[#1e2c6e] hover:bg-[#2a3c8e] text-white font-bold rounded-full px-7 shadow-lg shadow-blue-900/10">
              Iniciar sesión
            </Button>
          </Link>
        </div>

        {/* Mobile Toggle */}
        <button
          className="md:hidden text-[#1e2c6e]"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-2xl border-t border-slate-100 p-6 flex flex-col gap-4 animate-in slide-in-from-top duration-300">
          {navLinks.map((link) => (
            <Link
              key={link.name}
              href={link.href}
              className="text-slate-700 font-bold text-lg p-2"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {link.name}
            </Link>
          ))}
          <Link href="/login" className="w-full">
            <Button className="bg-[#1e2c6e] hover:bg-[#2a3c8e] text-white font-bold rounded-xl w-full py-6 text-lg mt-2">
              Iniciar sesión
            </Button>
          </Link>
        </div>
      )}
    </header>
  );
}